module.exports = "/_next/static/images/33e532966ba52bf3b3dc8c323be99d1e-mgm-10-million-desktop.jpg";